import { render, staticRenderFns } from "./OfferTimers.vue?vue&type=template&id=5c18df60"
import script from "./OfferTimers.vue?vue&type=script&lang=ts"
export * from "./OfferTimers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/OfferTimers.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fallocations%2Foffers%2FOfferTimers.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports